import { isArray, isEmpty, isFinite, mergeWith, isNil, isObjectLike, isString, omitBy, mapValues, keyBy } from 'lodash';

const patchCustomizer = <T>(objValue: any, srcValue: T): T | void => {
  if (isArray(objValue)) {
    return srcValue;
  }
};

// https://github.com/lodash/lodash/issues/1148
export const isNumeric = (value?: any): boolean => {
  if (typeof value === 'string') {
    if (value === '' || value.includes(' ') || value.includes('e')) {
      return false;
    }
    return !isNaN(Number(value));
  } else {
    return isFinite(value);
  }
};

export const isEmptyValue = (value: any): value is null | undefined | '' | Record<string, never> => {
  return isNil(value) || (isObjectLike(value) && isEmpty(value)) || (isString(value) && isEmpty(value));
};

/** @returns `object` merged with `patch`, replacing any arrays, mutating the `object` argument in the process */
export const patch = <T>(object: T, patch: Partial<T>): T => {
  return mergeWith(object, patch, patchCustomizer);
};

export const hasNonEmptyProperties = (obj: object): boolean => {
  return !isEmpty(omitBy(obj, isEmpty));
};

export const associateWith = <K extends string, V>(array: K[], valueSelector: (key: K) => V): Record<K, V> => {
  return mapValues(keyBy(array), valueSelector) as Record<K, V>;
};
